// Unpublished Work © 2023-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import * as icons from '@deere/icons';

function ItemContent(props) {
    const {
        description,
        iconName,
        label,
        leftIcon,
        rightIcon
    } = props;

    const Icon = iconName ? icons[iconName] : null;

    const itemIcon = React.useMemo(() => iconName ? (
        <Icon
            height={32}
            primary={'#767676'}
            width={32}
        />
    ) : null, [iconName]);

    const itemText = React.useMemo(() => description || label ? (
        <div className='label-container opener'>
            {
                label &&
                <span className='label'>{label}</span>
            }
            {
                description &&
                <p className='description'>{description}</p>
            }
        </div>
    ) : null, [description, label]);

    return (
        <>
            {leftIcon}
            {itemIcon}
            {itemText}
            {rightIcon}
        </>
    );
}

ItemContent.propTypes = {
    description: PropTypes.node,
    iconName: PropTypes.string,
    label: PropTypes.node,
    leftIcon: PropTypes.node,
    rightIcon: PropTypes.node
};

export default ItemContent;
